import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const LimitAndContinuity = () => (
  <QPhototModuleSubtopic
    title="limit and continuity"
    videos={[
      "https://www.youtube.com/embed/ZXNrEI5lIWs",
      "https://www.youtube.com/embed/jydFFxeWYkI",
      "https://www.youtube.com/embed/Xa8yAjojMSs"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_15.jpeg"
        },
        {
            image:"/cal_16.jpeg"
        },
        {
            image:"/cal_17.jpeg"
        },
        {
            image:"/cal_18.jpeg"
        }
    ]}
    exampleVideos={[]}
  />
);

export default LimitAndContinuity;
